import { db } from '../../firebase'
import { USERS, PROCESSES } from '../Collections'

const transactionsRef = uid => db.collection(`${USERS}/${uid}/${PROCESSES}`)

export const getKyc = uid => transactionsRef(uid).doc('kyc')
export const getRefer = uid => transactionsRef(uid).doc('refer')
